export default __webpack_public_path__ + "static/zincHero-e1956c034dea9d0f9b16f873780e18af.jpg";